import React from "react";

function Icon(props) {
  return (
    <div className={props.className}>
        <svg
            height={props.height}
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 270 270"
        >
        <path fill="none" d="M0 0H270V270H0z"></path>
        <path 
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M135 38.1c74.509 0 135 96.9 135 96.9s-60.491 96.9-135 96.9S0 135 0 135s60.491-96.9 135-96.9zm64.36 56.595c16.232 13.87 29.247 29.367 37.549 40.305-8.637 11.38-22.376 27.693-39.531 41.978-17.604 14.658-38.897 27.839-62.378 27.839s-44.774-13.181-62.378-27.839C55.467 162.693 41.728 146.38 33.091 135c8.302-10.938 21.317-26.435 37.549-40.305a67.532 67.532 0 00-3.332 21.018c0 37.36 30.332 67.692 67.692 67.692 37.36 0 67.692-30.332 67.692-67.692a67.532 67.532 0 00-3.332-21.018z"></path>
        </svg>
    </div>
  );
}

export default Icon;
